import { z } from 'zod';
import { EthnicityOptions } from '@govinity/shared-config';
export const userApplicationProfileUpsertSchema = z.object({
    employer: z.string().trim().nullish(),
    occupation: z.string().trim().nullish(),
    ethnicity: z.enum(EthnicityOptions).nullish(),
    qualifications: z.string().trim().nullish(),
    reason: z.string().trim().nullish(),
});
